type AreaCode = {
  area: string;
  postalCode: string;
};

type CountryAreaCities = {
  countryArea: string;
  cities: string[];
};

export const countryAreaPostalCodes: AreaCode[] = [
  // Municipios de Pinar del Río
  { area: "Pinar del Río", postalCode: "20100" },
  { area: "Consolación del Sur", postalCode: "23000" },
  { area: "Guane", postalCode: "23300" },
  { area: "La Palma", postalCode: "22600" },
  { area: "Los Palacios", postalCode: "22900" },
  { area: "Mantua", postalCode: "22200" },
  { area: "Minas de Matahambre", postalCode: "22300" },
  { area: "San Juan y Martínez", postalCode: "23200" },
  { area: "San Luis", postalCode: "23100" },
  { area: "Sandino", postalCode: "24150" },
  { area: "Viñales", postalCode: "22400" },
  { area: "Almacén Pinar del Río", postalCode: "20000" },

  // Municipios de Artemisa
  { area: "Alquízar", postalCode: "33700" },
  { area: "Artemisa", postalCode: "33800" },
  { area: "Bahía Honda", postalCode: "22600" },
  { area: "Bauta", postalCode: "32400" },
  { area: "Caimito", postalCode: "32300" },
  { area: "Candelaria", postalCode: "22700" },
  { area: "Guanajay", postalCode: "32200" },
  { area: "Güira de Melena", postalCode: "33600" },
  { area: "Mariel", postalCode: "32100" },
  { area: "San Antonio de los Baños", postalCode: "32500" },
  { area: "San Cristóbal", postalCode: "22800" },
  { area: "Almacén Artemisa", postalCode: "33000" },

  // Municipios de Mayabeque
  { area: "Batabanó", postalCode: "33400" },
  { area: "Bejucal", postalCode: "32600" },
  { area: "Güines", postalCode: "33900" },
  { area: "Jaruco", postalCode: "32800" },
  { area: "Madruga", postalCode: "33000" },
  { area: "Melena del Sur", postalCode: "33300" },
  { area: "Nueva Paz", postalCode: "33100" },
  { area: "Quivicán", postalCode: "33500" },
  { area: "San José de las Lajas", postalCode: "32700" },
  { area: "San Nicolás de Bari", postalCode: "33200" },
  { area: "Santa Cruz del Norte", postalCode: "32900" },
  { area: "Almacén Mayabeque", postalCode: "33000" },

  // Municipios de La Habana
  { area: "Arroyo Naranjo", postalCode: "10900" },
  { area: "Boyeros", postalCode: "10800" },
  { area: "Centro Habana", postalCode: "10200" },
  { area: "Cerro", postalCode: "10600" },
  { area: "Cotorro", postalCode: "14000" },
  { area: "Diez de Octubre", postalCode: "10700" },
  { area: "Guanabacoa", postalCode: "11100" },
  { area: "Habana del Este", postalCode: "12500" },
  { area: "Habana Vieja", postalCode: "10100" },
  { area: "La Lisa", postalCode: "17100" },
  { area: "Marianao", postalCode: "11500" },
  { area: "Playa", postalCode: "11300" },
  { area: "Plaza de la Revolución", postalCode: "10400" },
  { area: "Regla", postalCode: "11200" },
  { area: "San Miguel del Padrón", postalCode: "11000" },
  { area: "Almacén La Habana", postalCode: "10000" },

  // Municipios de Matanzas
  { area: "Calimete", postalCode: "43200" },
  { area: "Cárdenas", postalCode: "42110" },
  { area: "Ciénaga de Zapata", postalCode: "43000" },
  { area: "Colón", postalCode: "42400" },
  { area: "Jagüey Grande", postalCode: "43100" },
  { area: "Jovellanos", postalCode: "42600" },
  { area: "Limonar", postalCode: "42800" },
  { area: "Los Arabos", postalCode: "43300" },
  { area: "Martí", postalCode: "42300" },
  { area: "Matanzas", postalCode: "40100" },
  { area: "Pedro Betancourt", postalCode: "42700" },
  { area: "Perico", postalCode: "42500" },
  { area: "Unión de Reyes", postalCode: "42900" },
  { area: "Varadero", postalCode: "42200" },
  { area: "Almacén Matanzas", postalCode: "40000" },

  // Municipios de Cienfuegos
  { area: "Abreus", postalCode: "57700" },
  { area: "Aguada de Pasajeros", postalCode: "57100" },
  { area: "Cienfuegos", postalCode: "55100" },
  { area: "Cruces", postalCode: "57500" },
  { area: "Cumanayagua", postalCode: "57600" },
  { area: "Lajas", postalCode: "57400" },
  { area: "Palmira", postalCode: "57300" },
  { area: "Rodas", postalCode: "57200" },
  { area: "Almacén Cienfuegos", postalCode: "55000" },
  // Municipios de Villa Clara
  { area: "Santa Clara", postalCode: "50100" },
  { area: "Caibarién", postalCode: "52610" },
  { area: "Remedios", postalCode: "52500" },
  { area: "Sagua la Grande", postalCode: "51300" },
  { area: "Placetas", postalCode: "53200" },
  { area: "Encrucijada", postalCode: "51500" },
  { area: "Cifuentes", postalCode: "51400" },
  { area: "Ranchuelo", postalCode: "52200" },
  { area: "Camajuaní", postalCode: "52300" },
  { area: "Manicaragua", postalCode: "54200" },
  { area: "Corralillo", postalCode: "52100" },
  { area: "Quemado de Güines", postalCode: "52400" },
  { area: "Santo Domingo", postalCode: "53300" },
  { area: "Almacén Villa Clara", postalCode: "50000" },

  // Municipios de Sancti Spíritus
  { area: "Cabaiguán", postalCode: "62410" },
  { area: "Fomento", postalCode: "62500" },
  { area: "Jatibonico", postalCode: "62200" },
  { area: "La Sierpe", postalCode: "62700" },
  { area: "Sancti Spíritus", postalCode: "60100" },
  { area: "Taguasco", postalCode: "62300" },
  { area: "Trinidad", postalCode: "62600" },
  { area: "Yaguajay", postalCode: "62100" },
  { area: "Almacén Sancti Spíritus", postalCode: "62000" },

  // Municipios de Ciego de Ávila
  { area: "Ciego de Ávila", postalCode: "65100" },
  { area: "Chambas", postalCode: "67100" },
  { area: "Morón", postalCode: "67210" },
  { area: "Bolivia", postalCode: "67300" },
  { area: "Primero de Enero", postalCode: "67400" },
  { area: "Ciro Redondo", postalCode: "67500" },
  { area: "Florencia", postalCode: "67600" },
  { area: "Majagua", postalCode: "67700" },
  { area: "Venezuela", postalCode: "67800" },
  { area: "Baraguá", postalCode: "67900" },
  { area: "Almacén Ciego de Ávila", postalCode: "65000" },

  // Municipios de Camagüey
  { area: "Camagüey", postalCode: "70100" },
  { area: "Carlos Manuel de Céspedes", postalCode: "72100" },
  { area: "Esmeralda", postalCode: "72200" },
  { area: "Florida", postalCode: "72810" },
  { area: "Guáimaro", postalCode: "72600" },
  { area: "Jimaguayú", postalCode: "73000" },
  { area: "Minas", postalCode: "72400" },
  { area: "Najasa", postalCode: "73100" },
  { area: "Nuevitas", postalCode: "72510" },
  { area: "Santa Cruz del Sur", postalCode: "73200" },
  { area: "Sibanicú", postalCode: "72700" },
  { area: "Sierra de Cubitas", postalCode: "72300" },
  { area: "Almacén Camagüey", postalCode: "72000" },

  // Municipios de Holguín
  { area: "Holguín", postalCode: "80100" },
  { area: "Antilla", postalCode: "82100" },
  { area: "Báguanos", postalCode: "82200" },
  { area: "Banes", postalCode: "82300" },
  { area: "Cacocum", postalCode: "82400" },
  { area: "Calixto García", postalCode: "82500" },
  { area: "Cueto", postalCode: "82600" },
  { area: "Frank País", postalCode: "82700" },
  { area: "Gibara", postalCode: "82800" },
  { area: "Mayarí", postalCode: "82900" },
  { area: "Moa", postalCode: "83100" },
  { area: "Rafael Freyre", postalCode: "83200" },
  { area: "Sagua de Tánamo", postalCode: "83300" },
  { area: "Urbano Noris", postalCode: "83400" },
  { area: "Almacén Holguín", postalCode: "80000" },

  // Municipios de Las Tunas
  { area: "Las Tunas", postalCode: "75100" },
  { area: "Amancio", postalCode: "77100" },
  { area: "Colombia", postalCode: "77200" },
  { area: "Jesús Menéndez", postalCode: "77300" },
  { area: "Majibacoa", postalCode: "77400" },
  { area: "Manatí", postalCode: "77500" },
  { area: "Puerto Padre", postalCode: "77600" },
  { area: "Jobabo", postalCode: "77700" },
  { area: "Almacén Las Tunas", postalCode: "75000" },

  // Municipios de Granma
  { area: "Bayamo", postalCode: "85100" },
  { area: "Bartolomé Masó", postalCode: "87100" },
  { area: "Buey Arriba", postalCode: "87200" },
  { area: "Campechuela", postalCode: "87300" },
  { area: "Cauto Cristo", postalCode: "87400" },
  { area: "Guisa", postalCode: "87500" },
  { area: "Jiguaní", postalCode: "87600" },
  { area: "Manzanillo", postalCode: "87700" },
  { area: "Media Luna", postalCode: "87800" },
  { area: "Niquero", postalCode: "87900" },
  { area: "Pilón", postalCode: "88100" },
  { area: "Río Cauto", postalCode: "88200" },
  { area: "Yara", postalCode: "88300" },
  { area: "Almacén Granma", postalCode: "85000" },

  // Municipios de Santiago de Cuba
  { area: "Santiago de Cuba", postalCode: "90100" },
  { area: "Contramaestre", postalCode: "92100" },
  { area: "Guamá", postalCode: "92200" },
  { area: "Mella", postalCode: "92300" },
  { area: "Palma Soriano", postalCode: "92400" },
  { area: "San Luis", postalCode: "92500" },
  { area: "Segundo Frente", postalCode: "92600" },
  { area: "Songo-La Maya", postalCode: "92700" },
  { area: "Tercer Frente", postalCode: "92800" },
  { area: "Almacén Santiago de Cuba", postalCode: "90000" },

  // Municipio Especial
  { area: "Isla de la Juventud", postalCode: "23900" },
  { area: "Almacén Isla de la Juventud", postalCode: "23000" },
];

export const cities: CountryAreaCities[] = [
  {
    countryArea: "Artemisa",
    cities: [
      "Alquízar",
      "Artemisa",
      "Bahía Honda",
      "Bauta",
      "Caimito",
      "Candelaria",
      "Guanajay",
      "Güira de Melena",
      "Mariel",
      "San Antonio de los Baños",
      "San Cristóbal",
      "Almacén Artemisa",
    ],
  },
  {
    countryArea: "Camagüey",
    cities: [
      "Camagüey",
      "Carlos Manuel de Céspedes",
      "Esmeralda",
      "Florida",
      "Guáimaro",
      "Jimaguayú",
      "Minas",
      "Najasa",
      "Nuevitas",
      "Santa Cruz del Sur",
      "Sibanicú",
      "Sierra de Cubitas",
      "Almacén Camagüey",
    ],
  },
  {
    countryArea: "Ciego de Ávila",
    cities: [
      "Ciego de Ávila",
      "Chambas",
      "Morón",
      "Bolivia",
      "Primero de Enero",
      "Ciro Redondo",
      "Florencia",
      "Majagua",
      "Venezuela",
      "Baraguá",
      "Almacén Ciego de Ávila",
    ],
  },
  {
    countryArea: "Cienfuegos",
    cities: [
      "Abreus",
      "Aguada de Pasajeros",
      "Cienfuegos",
      "Cruces",
      "Cumanayagua",
      "Lajas",
      "Palmira",
      "Rodas",
      "Almacén Cienfuegos",
    ],
  },
  {
    countryArea: "Granma",
    cities: [
      "Bayamo",
      "Bartolomé Masó",
      "Buey Arriba",
      "Campechuela",
      "Cauto Cristo",
      "Guisa",
      "Jiguaní",
      "Manzanillo",
      "Media Luna",
      "Niquero",
      "Pilón",
      "Río Cauto",
      "Yara",
      "Almacén Granma",
    ],
  },
  {
    countryArea: "Holguín",
    cities: [
      "Holguín",
      "Antilla",
      "Báguanos",
      "Banes",
      "Cacocum",
      "Calixto García",
      "Cueto",
      "Frank País",
      "Gibara",
      "Mayarí",
      "Moa",
      "Rafael Freyre",
      "Sagua de Tánamo",
      "Urbano Noris",
      "Almacén Holguín",
    ],
  },
  {
    countryArea: "Isla de la Juventud",
    cities: ["Isla de la Juventud", "Almacén Isla de la Juventud"],
  },
  {
    countryArea: "La Habana",
    cities: [
      "Arroyo Naranjo",
      "Boyeros",
      "Centro Habana",
      "Cerro",
      "Cotorro",
      "Diez de Octubre",
      "Guanabacoa",
      "Habana del Este",
      "Habana Vieja",
      "La Lisa",
      "Marianao",
      "Playa",
      "Plaza de la Revolución",
      "Regla",
      "San Miguel del Padrón",
      "Almacén La Habana",
    ],
  },
  {
    countryArea: "Las Tunas",
    cities: [
      "Las Tunas",
      "Amancio",
      "Colombia",
      "Jesús Menéndez",
      "Majibacoa",
      "Manatí",
      "Puerto Padre",
      "Jobabo",
      "Almacén Las Tunas",
    ],
  },
  {
    countryArea: "Matanzas",
    cities: [
      "Calimete",
      "Cárdenas",
      "Ciénaga de Zapata",
      "Colón",
      "Jagüey Grande",
      "Jovellanos",
      "Limonar",
      "Los Arabos",
      "Martí",
      "Matanzas",
      "Pedro Betancourt",
      "Perico",
      "Unión de Reyes",
      "Varadero",
      "Almacén Matanzas",
    ],
  },
  {
    countryArea: "Mayabeque",
    cities: [
      "Batabanó",
      "Bejucal",
      "Güines",
      "Jaruco",
      "Madruga",
      "Melena del Sur",
      "Nueva Paz",
      "Quivicán",
      "San José de las Lajas",
      "San Nicolás de Bari",
      "Santa Cruz del Norte",
      "Almacén Mayabeque",
    ],
  },
  {
    countryArea: "Pinar del Río",
    cities: [
      "Consolación del Sur",
      "Guane",
      "La Palma",
      "Los Palacios",
      "Mantua",
      "Minas de Matahambre",
      "Pinar del Río",
      "San Juan y Martínez",
      "San Luis",
      "Sandino",
      "Viñales",
      "Almacén Pinar del Río",
    ],
  },
  {
    countryArea: "Sancti Spíritus",
    cities: [
      "Cabaiguán",
      "Fomento",
      "Jatibonico",
      "La Sierpe",
      "Sancti Spíritus",
      "Taguasco",
      "Trinidad",
      "Yaguajay",
      "Almacén Sancti Spíritus",
    ],
  },
  {
    countryArea: "Santiago de Cuba",
    cities: [
      "Santiago de Cuba",
      "Contramaestre",
      "Guamá",
      "Mella",
      "Palma Soriano",
      "San Luis",
      "Segundo Frente",
      "Songo-La Maya",
      "Tercer Frente",
      "Almacén Santiago de Cuba",
    ],
  },
  {
    countryArea: "Villa Clara",
    cities: [
      "Caibarién",
      "Camajuaní",
      "Cifuentes",
      "Corralillo",
      "Encrucijada",
      "Manicaragua",
      "Placetas",
      "Quemado de Güines",
      "Ranchuelo",
      "Remedios",
      "Sagua la Grande",
      "Santa Clara",
      "Santo Domingo",
      "Almacén Villa Clara",
    ],
  },
];

export function getPostalCodeByArea(area: string): string | null {
  const result = countryAreaPostalCodes.find(entry => entry.area === area);

  return result ? result.postalCode : null;
}

export function getCountryAreaByPostalCode(postalCode: string): string | null {
  const result = countryAreaPostalCodes.find(entry => entry.postalCode === postalCode);

  return result ? result.area : null;
}

export function getCitiesByCountryArea(countryArea: string): string[] | null {
  const result = cities.find(entry => entry.countryArea === countryArea);

  return result ? result.cities : null;
}

export function getCountriesAreas(): string[] {
  return cities.map(entry => entry.countryArea);
}

export default getPostalCodeByArea;
